export const API_PATH_ApiDeviceMgmtDeviceChangeLocationId = '/services/devices-mgtm/apiDeviceMgmtDeviceChangeLocationId';
